import { render } from "./TableReport.vue?vue&type=template&id=44f084c6&scoped=true"
import script from "./TableReport.vue?vue&type=script&lang=js"
export * from "./TableReport.vue?vue&type=script&lang=js"

import "./TableReport.vue?vue&type=style&index=0&id=44f084c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f084c6"]])

export default __exports__